import { takeEvery } from 'redux-saga/effects';

import * as phoneActionTypes from 'store/modules/phone/actionTypes';

import { load } from './utils';

export default function* listenLoad() {
  yield takeEvery(phoneActionTypes.LOAD, load);
}
